module.exports = __webpack_public_path__ + "c128f86d3f3506b70d68263bef526523.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/icons/DOC.png
// module id = G63g
// module chunks = 22